import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import fetch_45global from "/app/middleware/fetch.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  fetch_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-auth": () => import("/app/middleware/admin-auth.ts"),
  "admin-noauth": () => import("/app/middleware/admin-noauth.ts"),
  auth: () => import("/app/middleware/auth.ts"),
  noauth: () => import("/app/middleware/noauth.ts")
}